import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

export const BEACH_OPTIONS = [
  { slug: "poche-beach", name: "Poche Beach" },
  { slug: "san-clemente-pier", name: "San Clemente Pier" },
  { slug: "t-street", name: "T-Street Beach" },
  { slug: "doheny", name: "Doheny State Beach" }
] as const;

export type TidePrediction = { time: string; height: number; type: "High" | "Low" };
export type OceanConditions = {
  beach: { name: string; tideStation: string; tideStationName: string; buoy: string; buoyName: string; distanceMiles?: number; usedFallback?: boolean };
  predictions: TidePrediction[];
  buoy: null | {
    station: string; observedAt: string; waveHeightFt: number | null;
    dominantPeriodSeconds: number | null; waveDirectionDegrees: number | null; waterTemperatureF: number | null;
  };
  updatedAt: string;
  source: string;
};

const getOceanConditionsCall = httpsCallable<{ beachSlug: string; mode?: "home" | "current"; latitude?: number; longitude?: number }, OceanConditions>(functions, "getOceanConditions");

export async function getOceanConditions(beachSlug: string, location?: { latitude: number; longitude: number }) {
  const response = await getOceanConditionsCall({ beachSlug, mode: location ? "current" : "home", ...location });
  return response.data;
}
